export default "__VITE_ASSET__b74307b9__"